import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@mui/material';
import Language from '@mui/icons-material/Language';
import LangButton from './LangButton';
import { useTheme } from '@mui/material/styles';
import { getLanguageByShortName } from 'src/consts/languages';

function ContentLangBtn({ onContentLangChange, currentLang, title }) {
  const theme = useTheme();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.secondary,
      }}
    >
      <Icon aria-label="clear" style={{ marginRight: '8px' }}>
        <Language />
      </Icon>
      <LangButton
        {...{
          title,
          currentLang: getLanguageByShortName(currentLang),
          selectLang: language => onContentLangChange(language.shortName),
        }}
      />
    </div>
  );
}

ContentLangBtn.propTypes = {
  currentLang: PropTypes.string,
  title: PropTypes.string.isRequired,
  onContentLangChange: PropTypes.func.isRequired,
};

ContentLangBtn.defaultProps = {
  currentLang: null,
};

export default ContentLangBtn;
